<template>
  <div
    class="relative h-fit m-auto flex flex-col flex-1 justify-center ml-10 mr-10 xl:ml-auto xl:mr-[90px]"
  >
    <p class="xl:absolute top-[-117px] text-grays-900 text-lg font-regular">
      שלב 1 מתוך 2
    </p>
    <div class="flex flex-col h-fit gap-[25px]">
      <div class="flex flex-col">
        <h1 class="text-primary-700 text-3xl font-bold mt-[20px] mb-[12px]">
          {{ "שלום משפחת" }} {{ lname }}
        </h1>
        <p class="text-grays-900 text-lg font-regular max-w-[456px]">
          בואו נמצא את התחנה הכי קרובה אליכם ומיד תוכלו להתחיל לבחור מוצרים
          ולמלא את הבית. כל משפחה משוייכת לתחנה אחת בלבד תמיד תוכלו לשנות בקלות
          את התחנה שהגדרתם
        </p>
      </div>
      <station-address-form
        @form-submitted="handleNext"
        @stations-found="handleSearchStations"
      />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import StationAddressForm from "@/components/Global/StationAddressForm.vue";
import axiosInstance from "../../helpers/axios.js";

export default {
  name: "find-station-step-1",
  components: { StationAddressForm },
  data() {
    return {
      lname: "*****",
    };
  },
  methods: {
    ...mapActions({
      handleNextStep: "findStation/handleNextStep",
    }),
    async handleSearchStations({ lng, lat }) {
      try {
        const res = await axiosInstance.get(
          `/get_sites_by_distance/${lng}/${lat}`
        );
        this.$store.dispatch("findStation/updateStations", res.data);
      } catch (e) {
        console.error("Error fetching stations:", e);
      }
    },
    handleNext() {
      this.handleNextStep();
    },
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem("user"));
    this.lname = user.lname;
  },
};
</script>

<style>
</style>